module.exports = __webpack_public_path__ + "assets/img/im-keywords-banner-back.0d6a9070.png";